<template>
  <section v-editable="cms" :class="[name]" :style="mainCssVars">
    <grid
      :class="[`${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :reverse="reverse"
        :class="[`${name}__grid-item`, `${name}__content`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 3, width: 9 },
          { size: 1, x: 1, width: 12, reverse: true },
          { size: 3, x: 14, y: 1, width: 9, reverse: true },
        ]"
      >
        <a-copy :cms="cms" :class="`${name}__copy`" />
      </grid-item>
      <grid-item
        :reverse="reverse"
        :class="[`${name}__grid-item`, `${name}__media`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 13, width: 13 },
          { size: 1, x: 1, width: 12, reverse: true },
          { size: 3, x: 1, y: 1, width: 12, reverse: true },
        ]"
      >
        <transition name="fade">
          <a-video v-if="hasVideo" :cms="cms" :class="`${name}__video`" />
          <a-image-v2
            v-else-if="!hasVideo && (cms.image || {}).filename"
            :src="cms.image.filename"
            :alt="cms.image.alt"
            :layout="[
              { size: 0, bound: 667, ratio: [740, 833] },
              { size: 1, bound: 740, ratio: [740, 833] },
              { size: 2, bound: 740, ratio: [740, 833] },
              { size: 3, bound: 740, ratio: [740, 833] },
            ]"
            :class="`${name}__image`"
          />
        </transition>
      </grid-item>
    </grid>

    <component
      :is="item.component"
      v-for="item in cms.battenberg"
      :key="item._uid"
      v-editable="item"
      :cms="item"
      :class="`${name}__battenberg`"
    />
  </section>
</template>

<script>
import ASvgLogoX9 from '@/components/atoms/a-svgs/a-svg-logo-x9'
import AImageV2 from '@/components/atoms/a-images/a-image-v2'
import AVideo from '@/components/atoms/a-video/a-video'
import Colors from '~/mixins/colors'
import data from '~/components/organisms/o-health/o-health-x1-sq.data'
export default {
  components: { ASvgLogoX9, AImageV2, AVideo },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        return process.env.NODE_ENV === 'development' ? { ...data } : {}
      },
    },
  },

  data() {
    return {
      name: 'o-health-x1-sq',
      show: false,
    }
  },

  computed: {
    reverse() {
      return this.cms.reverse || false
    },
    hasVideo() {
      return (
        (this.cms.video || {}).filename ||
        (this.cms.youtube || {}).vimeo_raw ||
        (this.cms.vimeo || {}).vimeo_raw ||
        false
      )
    },
    cssClassVideo() {
      return this.hasVideo ? `video` : null
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#FFFFFF',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#212121'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--filter': this.cms.filter || null,
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-health-x1-sq {
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  display: grid;
  position: relative;
  overflow: hidden;

  &__grid {
    align-items: center;
  }

  &__content {
    @include container();

    min-height: inherit;
    display: grid;
    z-index: 2;
  }

  &__copy {
    margin: 100px 0;

    ::v-deep p:last-child {
      margin-bottom: 0;
    }
  }

  &__battenberg {
    margin: auto;
    display: inline-block;
    position: absolute;
    left: 0;
    bottom: -102px;
    right: 0;
  }

  ::v-deep a,
  ::v-deep .a-cta,
  ::v-deep button {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  ::v-deep img {
    filter: var(--filter);
  }
}

@include media-breakpoint-up(md) {
  .o-health-x1-sq {
    &__battenberg {
      top: 0;
      bottom: 0;
      width: 205px;
      height: 205px;
    }
  }
}
</style>
